import { Loading03Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Loader2 = /* @__PURE__ */ createIcon(Loading03Icon, 'Loader2');
